import { ResultPagDTO } from "@/interfaces/base-dto";
import { PrescricaoHistDTO, ProdutoUtilizadoDTO, ProdutoUtilizadoParmDTO } from "@/interfaces/prescription-hist";
import { ENDPOINTS } from "@/settings/api-settings";
import { AxiosResponse } from "axios";
import { from, Observable } from "rxjs";
import { map } from "rxjs/operators";
import { apiClient } from "./api";


export function listarDadosEvolucaoPaciente(idPaciente: Number, dias: Number): Observable<Array<PrescricaoHistDTO>> {
    return from(
        apiClient.get(ENDPOINTS.PRESCRIPTION_HIST, { idPaciente, dias }),
    ).pipe(map((r: any) => r.data || {}));
}

export function gerarXlsEvolucaoPaciente(idPaciente: Number, dias: Number): Observable<AxiosResponse> {
    return from(
        apiClient.download(ENDPOINTS.PRESCRIPTION_HIST_XLS, { idPaciente, dias }),
    );
}

export function gerarPdfEvolucaoPaciente(idPaciente: Number, dias: Number): Observable<AxiosResponse> {
    return from(
        apiClient.download(ENDPOINTS.PRESCRIPTION_HIST_PDF, { idPaciente, dias }),
    );
}

export function listProductsCombo(): Observable<any[]> {
    return from(
        apiClient.get(ENDPOINTS.PRESCRIPTION_HIST_PRODUCTS_COMBO),
    ).pipe(map((r: any) => r.data || {}));
}

export function listUsedProducts(filtros: ProdutoUtilizadoParmDTO): Observable<ResultPagDTO<ProdutoUtilizadoDTO>> {
    return from(
        apiClient.get(ENDPOINTS.PRESCRIPTION_HIST_PRODUCTS, filtros),
    ).pipe(map((r: any) => r.data || {}));
}

export function buildUsedProductsXlsx(filtros: ProdutoUtilizadoParmDTO): Observable<AxiosResponse> {
    return from(
        apiClient.download(ENDPOINTS.PRESCRIPTION_HIST_PRODUCTS_XLSX, filtros),
    );
}